
import { request } from "@weapp/utils";


//获取推荐拿福利info
export const getInviteWelfare = () => {
    const formData = new FormData();
    formData.append('userId', window.TEAMS?.currentUser?.userId);
    return request({
        url: `/api/basicserver/inviteteams/findInviteRuleInfo`,
        method: "post",
        data: formData,
    });
};
//获取推荐详情列表
export const getInviteTeams = (formData: FormData) => {
    return request({
        url: `/api/basicserver/inviteteams/findInviteTeams`,
        method: "post",
        data: formData,
    });
};
